import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};

IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
export default function DropdownSelect(_ref) {
  var _classnames3;

  var options = _ref.options,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? false : _ref$right,
      _ref$mouseOver = _ref.mouseOver,
      mouseOver = _ref$mouseOver === void 0 ? false : _ref$mouseOver,
      defaultValue = _ref.defaultValue,
      onSelect = _ref.onSelect,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className;

  var _useDropdown = useDropdown({
    mouseOver: mouseOver
  }),
      buttonRef = _useDropdown.buttonRef,
      contentRef = _useDropdown.contentRef,
      show = _useDropdown.show,
      setShow = _useDropdown.setShow,
      listeners = _useDropdown.listeners;

  var _useState = useState(),
      selected = _useState[0],
      setSelected = _useState[1];

  var handleMouseOver = useCallback(function () {
    if (!disabled) {
      listeners.handleMouseOver();
    }
  }, [listeners, disabled]);
  var handleMouseLeave = useCallback(function () {
    if (!disabled) {
      listeners.handleMouseLeave();
    }
  }, [listeners, disabled]);
  var handleClick = useCallback(function () {
    if (!disabled) {
      listeners.handleClick();
    }
  }, [listeners, disabled]);
  var handleSelect = useCallback(function (value) {
    return function () {
      if (!disabled) {
        var selectOption = options.find(function (option) {
          return option.value == value;
        });
        setSelected(selectOption);
        setShow(false);

        if (onSelect) {
          onSelect(selectOption);
        }
      }
    };
  }, [disabled]);
  useEffect(function () {
    if (!defaultValue) {
      setSelected(options[0]);
    }
  }, [defaultValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.dropdown, className, _defineProperty({}, styles.sort, className == "sort")),
    onMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave,
    children: [/*#__PURE__*/_jsx("div", {
      ref: buttonRef,
      className: classnames(styles.selected, _defineProperty({}, styles.show, show)),
      onClick: handleClick,
      children: selected && /*#__PURE__*/_jsxs("span", {
        children: [selected.text, /*#__PURE__*/_jsx("span", {
          className: styles.caret,
          children: /*#__PURE__*/_jsx(IconArrow, {})
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: classnames(styles.content, (_classnames3 = {}, _defineProperty(_classnames3, styles.show, show), _defineProperty(_classnames3, styles.right, right), _classnames3)),
      children: !disabled && options.map(function (option) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.option,
          onClick: handleSelect(option.value),
          children: option.text
        }, "dropdownselect-".concat(option.value));
      })
    })]
  });
}